import React from 'react';
import Form from 'react-bootstrap/Form';
import RuleEditor from './RuleEditor';
import './RuleGenerator.css';

class RuleGenerator extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      rule: '',
    };
  }
  render() {
    return (
      <div className="RuleGenerator">
        <RuleEditor className="RuleGenerator-editor" onChange={rule => this.setState({rule})}/>
        <div className="RuleGenerator-output">
          <Form.Label>
            Then use this magic spell! <span role="img" aria-label="sparkles">✨</span>
          </Form.Label>
          <Form.Control 
              as="textarea" 
              className="RuleGenerator-output-code"
              rows="3" 
              readOnly 
              value={this.state.rule ? this.state.rule.toString() : ''}
              onClick={event => { event.target.focus(); event.target.select(); }} />
        </div>
      </div>
    );
    }
}

export default RuleGenerator;
